import { render, staticRenderFns } from "./Deselect.vue?vue&type=template&id=07226b48&scoped=true"
import script from "./Deselect.vue?vue&type=script&lang=js"
export * from "./Deselect.vue?vue&type=script&lang=js"
import style0 from "./Deselect.vue?vue&type=style&index=0&id=07226b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07226b48",
  null
  
)

export default component.exports